import React from 'react';
import PropTypes from 'prop-types';

const EmptyState = ({ 
  title, 
  description,
  icon = null
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state__content">
        {icon && <div className="empty-state__icon">{icon}</div>}
        <h3 className="empty-state__title">{title}</h3>
        {description && <p className="empty-state__description">{description}</p>}
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string
};

export default EmptyState;